"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[399],{

/***/ 1399:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "SearchHero": function() { return /* binding */ SearchHero; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/gsap/index.js + 2 modules
var gsap = __webpack_require__(6038);
// EXTERNAL MODULE: ./node_modules/gsap/dist/CustomEase.js
var CustomEase = __webpack_require__(4347);
var CustomEase_default = /*#__PURE__*/__webpack_require__.n(CustomEase);
// EXTERNAL MODULE: ./node_modules/gsap/dist/ScrollTrigger.js
var ScrollTrigger = __webpack_require__(6546);
var ScrollTrigger_default = /*#__PURE__*/__webpack_require__.n(ScrollTrigger);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./src/components/utils/gsapVariables.ts
var gsapVariables = __webpack_require__(1464);
// EXTERNAL MODULE: ./src/components/utils/useIsSmallerThan.ts
var useIsSmallerThan = __webpack_require__(294);
// EXTERNAL MODULE: ./src/components/utils/useIsGreaterThan.ts
var useIsGreaterThan = __webpack_require__(5732);
// EXTERNAL MODULE: ./src/components/utils/useIsomorphicLayoutEffect.tsx
var useIsomorphicLayoutEffect = __webpack_require__(8058);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(655);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/@react-aria/visually-hidden/dist/module.js
var dist_module = __webpack_require__(4140);
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/Transition.js + 2 modules
var Transition = __webpack_require__(9325);
// EXTERNAL MODULE: ./src/components/utils/useOnClickOutside.tsx
var useOnClickOutside = __webpack_require__(2517);
// EXTERNAL MODULE: ./public/icons/small/Check-Naked.svg
var Check_Naked = __webpack_require__(8752);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(9521);
// EXTERNAL MODULE: ./src/components/utils/focusStyle.ts
var focusStyle = __webpack_require__(1586);
// EXTERNAL MODULE: ./src/components/utils/mediaQueries.ts
var mediaQueries = __webpack_require__(5672);
// EXTERNAL MODULE: ./public/icons/small/Arrow-Thin-Down.svg
var Arrow_Thin_Down = __webpack_require__(7879);
;// CONCATENATED MODULE: ./src/components/elements/SelectWithIcon/SelectWithIcon.styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    opacity: 1;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    opacity: 0;\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    opacity: 0;\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    transform: translate3d(0, 0, 0);\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    transform: translate3d(0, 100vh, 0);\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    transform: translate3d(0, 100vh, 0);\n  "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      &::after {\n        content: '';\n        position: absolute;\n        top: -3px;\n        right: 0;\n        bottom: -3px;\n        left: -3px;\n        border: var(--distance-static-3xs) solid var(--color-focus-dark);\n        border-radius: var(--border-radius-s);\n      }\n    "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  cursor: pointer;\n  border: var(--distance-static-3xs) solid transparent;\n  padding: var(--distance-dynamic-xxs) var(--distance-static-s);\n  background-color: transparent;\n  color: currentColor;\n\n  &::before {\n    content: '';\n    position: absolute;\n    right: 0;\n    height: var(--distance-static-xl);\n    width: 1px;\n    background: var(--color-searchinput-divider);\n  }\n\n  ",
        ";\n\n  &:focus-visible {\n    &::after {\n      top: -3px;\n      right: 0;\n      bottom: -3px;\n      left: -3px;\n      border-radius: var(--border-radius-s);\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: fixed;\n  z-index: var(--zindex-l);\n  left: 0;\n  right: 0;\n  bottom: 0;\n  padding: var(--distance-static-m);\n  margin: 0;\n  list-style: none;\n  background-color: var(--color-surface-light);\n  border-radius: var(--border-radius-l) var(--border-radius-l) 0 0;\n  transition: transform 0.3s ease-in-out;\n\n  ",
        ";\n\n  @media screen and (",
        ") {\n    position: absolute;\n    top: calc(100% + var(--distance-static-3xs));\n    bottom: unset;\n    width: 0;\n    min-width: 248px;\n    padding: 0;\n    box-shadow: var(--shadow-m);\n    border-radius: var(--border-radius-s);\n    transition: none;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      background-color: var(--color-searchinput-result-hover);\n    "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  cursor: pointer;\n  padding: var(--distance-static-xs) var(--distance-static-s);\n\n  ",
        "\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: var(--zindex-l);\n  background: var(--color-overlay-background);\n  transition: opacity 0.2s ease-in-out;\n\n  ",
        ";\n\n  @media screen and (",
        ") {\n    display: none;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      transform: rotate(180deg);\n    "
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  transition: transform 0.2s ease-in-out;\n\n  ",
        "\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-right: var(--distance-static-s);\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}



var shimTransitionStyles = {
    entering: null,
    entered: (0,styled_components_browser_esm/* css */.iv)(_templateObject()),
    exiting: (0,styled_components_browser_esm/* css */.iv)(_templateObject1()),
    exited: (0,styled_components_browser_esm/* css */.iv)(_templateObject2()),
    unmounted: null
};
var listTransitionStyles = {
    entering: null,
    entered: (0,styled_components_browser_esm/* css */.iv)(_templateObject3()),
    exiting: (0,styled_components_browser_esm/* css */.iv)(_templateObject4()),
    exited: (0,styled_components_browser_esm/* css */.iv)(_templateObject5()),
    unmounted: null
};
var StyledSelectValue = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-4b61c3c2-0"
})(_templateObject7(), focusStyle/* focusStyleDark */.x4, function(param) {
    var $isOpen = param.$isOpen;
    return $isOpen && (0,styled_components_browser_esm/* css */.iv)(_templateObject6());
});
var StyledSelectList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-4b61c3c2-1"
})(_templateObject8(), function(param) {
    var $state = param.$state;
    return $state && listTransitionStyles[$state];
}, mediaQueries/* tabletLandscape */.yJ);
var StyledSelectListItem = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-4b61c3c2-2"
})(_templateObject10(), function(param) {
    var $isActive = param.$isActive;
    return $isActive && (0,styled_components_browser_esm/* css */.iv)(_templateObject9());
});
var StyledShim = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4b61c3c2-3"
})(_templateObject11(), function(param) {
    var $state = param.$state;
    return $state && shimTransitionStyles[$state];
}, mediaQueries/* tabletLandscape */.yJ);
var StyledArrow = (0,styled_components_browser_esm/* default */.ZP)(Arrow_Thin_Down/* default */.Z).withConfig({
    componentId: "sc-4b61c3c2-4"
})(_templateObject13(), function(param) {
    var $isOpen = param.$isOpen;
    return $isOpen && (0,styled_components_browser_esm/* css */.iv)(_templateObject12());
});
var StyledOptionIcon = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-4b61c3c2-5"
})(_templateObject14());
var StyledListItemContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4b61c3c2-6"
})(_templateObject15());

;// CONCATENATED MODULE: ./src/components/elements/SelectWithIcon/SelectWithIcon.tsx







var SelectWithIcon = function(param) {
    var buttonLabel = param.buttonLabel, options = param.options, onChange = param.onChange;
    var ref;
    var ref1 = (0,react.useState)(false), isOpen = ref1[0], setIsOpen = ref1[1];
    var ref2 = (0,react.useState)(options[0].value), selectedValue = ref2[0], setSelectedValue = ref2[1];
    var ref3 = (0,react.useState)(0), focusedIndex = ref3[0], setFocusedIndex = ref3[1];
    var listRef = (0,react.useRef)(null);
    var shimRef = (0,react.useRef)(null);
    var closeList = function() {
        setIsOpen(false);
    };
    var selectValue = function(value) {
        setSelectedValue(value);
        onChange(value);
        setIsOpen(false);
    };
    (0,useOnClickOutside/* useOnClickOutside */.t)(listRef, closeList);
    var handleArrowUp = function() {
        setFocusedIndex(Math.max(0, focusedIndex - 1));
    };
    var handleArrowDown = function() {
        setFocusedIndex(Math.min(options.length - 1, focusedIndex + 1));
    };
    var handleEnter = function() {
        selectValue(options[focusedIndex].value);
    };
    var handleEscape = function() {
        closeList();
    };
    var keyActions = {
        ArrowUp: handleArrowUp,
        ArrowDown: handleArrowDown,
        Enter: handleEnter,
        Escape: handleEscape
    };
    var handleKeyDown = function(e) {
        if (e.key !== "Tab") e.preventDefault();
        var action = keyActions[e.key];
        action === null || action === void 0 ? void 0 : action();
    };
    // mouse navigation for the suggestion list
    var handleMouseEnter = (0,react.useCallback)(function(index) {
        setFocusedIndex(index);
    }, []);
    var handleMouseLeave = (0,react.useCallback)(function() {
        setFocusedIndex(0);
    }, []);
    var handleOptionClick = function(value) {
        selectValue(value);
    };
    var onSelectValue = function(e) {
        e.preventDefault();
        e.stopPropagation();
        setIsOpen(!isOpen);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSelectValue, {
                onClick: onSelectValue,
                $isOpen: isOpen,
                onKeyDown: handleKeyDown,
                type: "button",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledOptionIcon, {
                        children: (ref = options.find(function(o) {
                            return o.value === selectedValue;
                        })) === null || ref === void 0 ? void 0 : ref.icon
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledArrow, {
                        $isOpen: isOpen
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_module/* VisuallyHidden */.T, {
                        children: buttonLabel
                    })
                ]
            }),
            isOpen && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Transition/* default */.ZP, {
                        nodeRef: shimRef,
                        in: isOpen,
                        timeout: {
                            enter: 0,
                            exit: 250
                        },
                        unmountOnExit: true,
                        appear: true,
                        children: function(shimState) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledShim, {
                                ref: shimRef,
                                $state: shimState
                            });
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Transition/* default */.ZP, {
                        nodeRef: listRef,
                        in: isOpen,
                        timeout: {
                            enter: 0,
                            exit: 250
                        },
                        unmountOnExit: true,
                        appear: true,
                        children: function(listState) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSelectList, {
                                $state: listState,
                                ref: listRef,
                                children: options.map(function(option, index) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSelectListItem, {
                                        $isActive: index === focusedIndex,
                                        $isSelected: option.value === selectedValue,
                                        onClick: function() {
                                            return handleOptionClick(option.value);
                                        },
                                        onMouseEnter: function() {
                                            return handleMouseEnter(index);
                                        },
                                        onMouseLeave: handleMouseLeave,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledListItemContent, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledOptionIcon, {
                                                        children: option.icon
                                                    }),
                                                    option.label
                                                ]
                                            }),
                                            option.value === selectedValue && /*#__PURE__*/ (0,jsx_runtime.jsx)(Check_Naked/* default */.Z, {})
                                        ]
                                    }, option.value);
                                })
                            });
                        }
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/utils/useKeyboardNavigation.ts
var useKeyboardNavigation = __webpack_require__(4056);
;// CONCATENATED MODULE: ./public/icons/small/Search.svg
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    role: "presentation",
    focusable: "false"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 10a6 6 0 1 1-12 0 6 6 0 0 1 12 0Zm-1.416 5.29a7 7 0 1 1 .707-.707l5.707 5.708-.707.707-5.707-5.707Z",
    fill: "currentColor"
  })));
};
/* harmony default export */ var Search = (SvgSearch);
// EXTERNAL MODULE: ./src/lib/tracking/useSnowplow.tsx
var useSnowplow = __webpack_require__(3545);
// EXTERNAL MODULE: ./src/utils/getSlugFromPath.ts
var getSlugFromPath = __webpack_require__(131);
// EXTERNAL MODULE: ./src/utils/search/api.ts
var api = __webpack_require__(168);
// EXTERNAL MODULE: ./src/utils/search/propertyData.ts
var propertyData = __webpack_require__(5769);
// EXTERNAL MODULE: ./src/utils/appendSphParam.ts
var appendSphParam = __webpack_require__(8874);
// EXTERNAL MODULE: ./src/components/elements/IconButton/IconButton.tsx
var IconButton = __webpack_require__(5556);
// EXTERNAL MODULE: ./src/components/elements/Copy/Copy.tsx
var Copy = __webpack_require__(8765);
// EXTERNAL MODULE: ./src/components/elements/TextRadio/TextRadio.tsx + 1 modules
var TextRadio = __webpack_require__(1442);
;// CONCATENATED MODULE: ./src/components/utils/blinkInputOpacityToPreventScrollingWhenFocused.ts

function blinkInputOpacityToPreventScrollingWhenFocused_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  0% { opacity: 0; }\n  100% { opacity: 1; }\n"
    ]);
    blinkInputOpacityToPreventScrollingWhenFocused_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

// When an input element gets focused, iOS Safari tries to put it in the center by scrolling (and zooming.)
// Zooming can be easily disabled using a meta tag, but the scrolling hasn't been quite easy.
// The main quirk (I think) is that iOS Safari changes viewport when scrolling; i.e., toolbars shrink.
// Since the viewport _should_ change, it thinks the input _will_ move, so it _should_ scroll, always.
// Even times when it doesn't need to scroll—the input is fixed, all we need is the keyboard—
// the window always scrolls _up and down_ resulting in some janky animation.
// However, iOS Safari doesn't scroll when the input **has opacity of 0 or is completely clipped.**
var blinkInputOpacityToPreventScrollingWhenFocused = (0,styled_components_browser_esm/* keyframes */.F4)(blinkInputOpacityToPreventScrollingWhenFocused_templateObject());

;// CONCATENATED MODULE: ./src/components/modules/SearchForm/SearchForm.styled.ts

function SearchForm_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n"
    ]);
    SearchForm_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SearchForm_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 100%;\n\n  ",
        ";\n\n  &:focus-within {\n    &::after {\n      top: -1px;\n      right: -1px;\n      bottom: -1px;\n      left: -3px;\n      border-radius: var(--border-radius-s);\n    }\n  }\n"
    ]);
    SearchForm_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SearchForm_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  padding: var(--distance-dynamic-xxs) var(--distance-static-5xl)\n    var(--distance-dynamic-xxs) var(--distance-static-s);\n  background-color: var(--color-surface-light);\n  caret-color: var(--color-searchinput-caret);\n  color: var(--color-text-highlight);\n  font-size: var(--font-size-dynamic-xs);\n  line-height: var(--line-height-static-xl);\n  border: none;\n  appearance: textfield;\n\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n\n  &::placeholder {\n    color: var(--color-searchinput-placeholder);\n  }\n\n  &::-webkit-search-cancel-button {\n    display: none;\n  }\n\n  &:focus {\n    outline: none;\n    // Prevent scrolling when focused\n    animation: ",
        " 0.01s;\n  }\n"
    ]);
    SearchForm_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function SearchForm_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  background-color: var(--color-input-text-enabled);\n  position: relative;\n  border-radius: var(--border-radius-s);\n  border: 1px solid var(--color-input-border-idle);\n\n  @media (hover: hover) {\n    &:hover {\n      border-color: var(\n        ",
        "\n      );\n      box-shadow: var(--shadow-m);\n    }\n  }\n\n  &:focus {\n    outline: 0;\n  }\n"
    ]);
    SearchForm_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function SearchForm_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      background: var(--color-cta-active);\n    "
    ]);
    SearchForm_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function SearchForm_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  right: var(--distance-static-xs);\n  cursor: pointer;\n\n  ",
        ";\n"
    ]);
    SearchForm_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function SearchForm_styled_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 50%;\n  right: var(--distance-dynamic-xl);\n  transform: translateY(-50%);\n  cursor: pointer;\n  z-index: var(--zindex-m);\n"
    ]);
    SearchForm_styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function SearchForm_styled_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 100%;\n  width: 100%;\n  padding: 0;\n  margin: 0;\n  background-color: var(--color-light);\n  border-radius: var(--border-radius-s);\n  box-shadow: var(--shadow-m);\n  list-style: none;\n  z-index: var(--zindex-m);\n  max-height: 350px;\n  overflow-y: auto;\n"
    ]);
    SearchForm_styled_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function SearchForm_styled_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      background-color: var(--color-searchinput-result-hover);\n    "
    ]);
    SearchForm_styled_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function SearchForm_styled_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  padding: var(--distance-static-xs) var(--distance-static-s);\n  ",
        ";\n\n  @media screen and (",
        ") {\n    padding: var(--distance-static-xs) var(--distance-static-xxl);\n  }\n"
    ]);
    SearchForm_styled_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function SearchForm_styled_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  margin-right: var(--distance-static-s);\n"
    ]);
    SearchForm_styled_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function SearchForm_styled_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n"
    ]);
    SearchForm_styled_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function SearchForm_styled_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: var(--color-text-dark-subdued);\n  text-transform: capitalize;\n"
    ]);
    SearchForm_styled_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function SearchForm_styled_templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: var(--distance-static-m);\n"
    ]);
    SearchForm_styled_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}



var StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f3760fdf-0"
})(SearchForm_styled_templateObject());
var StyledSearchInputWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f3760fdf-1"
})(SearchForm_styled_templateObject1(), focusStyle/* focusWithinStyleDark */.PQ);
var StyledSearchInput = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
    componentId: "sc-f3760fdf-2"
})(SearchForm_styled_templateObject2(), blinkInputOpacityToPreventScrollingWhenFocused);
var StyledForm = styled_components_browser_esm/* default.form.withConfig */.ZP.form.withConfig({
    componentId: "sc-f3760fdf-3"
})(SearchForm_styled_templateObject3(), function(param) {
    var $error = param.$error;
    return $error ? "--color-input-border-error" : "--color-input-border-hover";
});
var StyledIconButton = (0,styled_components_browser_esm/* default */.ZP)(IconButton/* IconButton */.h).withConfig({
    componentId: "sc-f3760fdf-4"
})(SearchForm_styled_templateObject5(), function(param) {
    var $isActive = param.$isActive;
    return $isActive && (0,styled_components_browser_esm/* css */.iv)(SearchForm_styled_templateObject4());
});
var StyledIconCloseButton = (0,styled_components_browser_esm/* default */.ZP)(IconButton/* IconButton */.h).withConfig({
    componentId: "sc-f3760fdf-5"
})(SearchForm_styled_templateObject6());
var StyledSuggestions = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-f3760fdf-6"
})(SearchForm_styled_templateObject7());
var StyledSuggestionItem = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-f3760fdf-7"
})(SearchForm_styled_templateObject9(), function(param) {
    var $isActive = param.$isActive;
    return $isActive && (0,styled_components_browser_esm/* css */.iv)(SearchForm_styled_templateObject8());
}, mediaQueries/* laptop */.PJ);
var StyledSuggestionIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f3760fdf-8"
})(SearchForm_styled_templateObject10());
var StyledDescription = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f3760fdf-9"
})(SearchForm_styled_templateObject11());
var StyledType = (0,styled_components_browser_esm/* default */.ZP)(Copy/* Copy */.CK).withConfig({
    componentId: "sc-f3760fdf-10"
})(SearchForm_styled_templateObject12());
var StyledTextRadio = (0,styled_components_browser_esm/* default */.ZP)(TextRadio/* TextRadio */.T).withConfig({
    componentId: "sc-f3760fdf-11"
})(SearchForm_styled_templateObject13());

// EXTERNAL MODULE: ./public/icons/small/Cross-Naked.svg
var Cross_Naked = __webpack_require__(9005);
;// CONCATENATED MODULE: ./src/components/modules/SearchForm/SearchInput.tsx




var SearchInput = /*#__PURE__*/ react.forwardRef(function(param, ref) {
    var query = param.query, placeholder = param.placeholder, onChange = param.onChange, onKeyDown = param.onKeyDown, onFocus = param.onFocus, cleanInput = param.cleanInput;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSearchInput, {
                ref: ref,
                type: "search",
                placeholder: placeholder,
                onFocus: onFocus,
                onChange: onChange,
                onKeyDown: onKeyDown,
                value: query,
                name: "searchInput",
                autoComplete: "off"
            }),
            query && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledIconCloseButton, {
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Cross_Naked/* default */.Z, {}),
                onClick: cleanInput,
                label: "close",
                variant: "primaryAlt",
                shape: "square"
            })
        ]
    });
});
SearchInput.displayName = "SearchInput";

// EXTERNAL MODULE: ./src/components/utils/useCustomTranslation.tsx
var useCustomTranslation = __webpack_require__(4422);
;// CONCATENATED MODULE: ./public/icons/small/City.svg
var City_path;
function City_extends() { City_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return City_extends.apply(this, arguments); }

var SvgCity = function SvgCity(props) {
  return /*#__PURE__*/react.createElement("svg", City_extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    role: "presentation",
    focusable: "false"
  }, props), City_path || (City_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 5.566V20h2v-4h4v4h2V5.566l-4-2.4-4 2.4ZM13 17v3h-2v-3h2Zm9 4V9l-5 1.667V5l-5-3-5 3v4H2v12h20Zm-5-9.28V20h4v-9.613l-4 1.334ZM7 10H3v10h4V10Zm7-2V7h-4v1h4Zm0 2v1h-4v-1h4Zm0 4v-1h-4v1h4ZM4 12h2v1H4v-1Zm16 3v-1h-2v1h2ZM4 15h2v1H4v-1Zm16 3v-1h-2v1h2Z",
    fill: "currentColor"
  })));
};
/* harmony default export */ var City = (SvgCity);
// EXTERNAL MODULE: ./public/icons/small/House.svg
var House = __webpack_require__(7739);
// EXTERNAL MODULE: ./public/icons/small/Pin.svg
var Pin = __webpack_require__(2194);
;// CONCATENATED MODULE: ./public/icons/small/Property-Multiple.svg
var Property_Multiple_path;
function Property_Multiple_extends() { Property_Multiple_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return Property_Multiple_extends.apply(this, arguments); }

var SvgPropertyMultiple = function SvgPropertyMultiple(props) {
  return /*#__PURE__*/react.createElement("svg", Property_Multiple_extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    role: "presentation",
    focusable: "false"
  }, props), Property_Multiple_path || (Property_Multiple_path = /*#__PURE__*/react.createElement("path", {
    d: "m15.549 4 6.45 6.406-.705.71-5.745-5.707-2.472 2.455-.705-.71L15.55 4ZM8.45 5.934 2 12.34l.705.71 5.744-5.707 5.745 5.706.705-.71-6.45-6.405ZM4.848 14.08V19h7.203v-4.92h1V20H3.848v-5.92h1ZM19.16 12.135v4.921h-4.085v1h5.085v-5.92h-1Z",
    fill: "currentColor"
  })));
};
/* harmony default export */ var Property_Multiple = (SvgPropertyMultiple);
// EXTERNAL MODULE: ./src/components/modules/SearchForm/HighlightedText.tsx
var HighlightedText = __webpack_require__(6355);
;// CONCATENATED MODULE: ./src/components/modules/SearchForm/SuggestionItem.tsx









var SuggestionItem = function(param) {
    var query = param.query, suggestion = param.suggestion, isActive = param.isActive, handleSuggestionClick = param.handleSuggestionClick, handleSuggestionMouseEnter = param.handleSuggestionMouseEnter, handleSuggestionMouseLeave = param.handleSuggestionMouseLeave;
    var t = (0,useCustomTranslation/* useCustomTranslation */.h)().t;
    var iconsMapping = function(type) {
        var ref, ref1;
        var placeTypes = {
            region: {
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Pin/* default */.Z, {}),
                name: t("searchHero.searchForm.placeType.administrative_area_level_1")
            },
            country: {
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Pin/* default */.Z, {}),
                name: t("searchHero.searchForm.placeType.country")
            },
            city: {
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(City, {}),
                name: t("searchHero.searchForm.placeType.locality")
            },
            place: {
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Pin/* default */.Z, {}),
                name: t("searchHero.searchForm.placeType.natural_feature")
            },
            neighborhood: {
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Property_Multiple, {}),
                name: t("searchHero.searchForm.placeType.neighborhood")
            },
            subLocality: {
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Pin/* default */.Z, {}),
                name: t("searchHero.searchForm.placeType.sublocality")
            },
            postalCode: {
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Property_Multiple, {}),
                name: t("searchHero.searchForm.placeType.postal_code")
            },
            displayId: {
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(House/* default */.Z, {}),
                name: suggestion.marketingTitle || "Expos\xe9"
            }
        };
        var _icon, ref2;
        return {
            icon: (_icon = placeTypes[type].icon) !== null && _icon !== void 0 ? _icon : placeTypes === null || placeTypes === void 0 ? void 0 : placeTypes.place.icon,
            placeType: (ref2 = (ref = placeTypes[type]) === null || ref === void 0 ? void 0 : ref.name) !== null && ref2 !== void 0 ? ref2 : placeTypes === null || placeTypes === void 0 ? void 0 : (ref1 = placeTypes.place) === null || ref1 === void 0 ? void 0 : ref1.name
        };
    };
    var _type;
    var ref = iconsMapping((_type = suggestion.type) !== null && _type !== void 0 ? _type : "place"), _icon = ref.icon, icon = _icon === void 0 ? "" : _icon, _placeType = ref.placeType, placeType = _placeType === void 0 ? "" : _placeType;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSuggestionItem, {
        onClick: handleSuggestionClick,
        onMouseEnter: handleSuggestionMouseEnter,
        onMouseLeave: handleSuggestionMouseLeave,
        $isActive: isActive,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSuggestionIcon, {
                children: suggestion.type && icon
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledDescription, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HighlightedText/* HighlightedText */.h, {
                            text: suggestion.description,
                            highlightedText: query
                        })
                    }),
                    suggestion.type && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledType, {
                        text: placeType,
                        size: "m"
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/modules/SearchForm/SuggestionList.tsx





var SuggestionList = function(param) {
    var query = param.query, suggestions = param.suggestions, focusedSuggestionIndex = param.focusedSuggestionIndex, handleClickOutside = param.handleClickOutside, handleSuggestionClick = param.handleSuggestionClick, handleSuggestionMouseEnter = param.handleSuggestionMouseEnter, handleSuggestionMouseLeave = param.handleSuggestionMouseLeave;
    var suggestionsRef = (0,react.useRef)(null);
    (0,useOnClickOutside/* useOnClickOutside */.t)(suggestionsRef, handleClickOutside);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSuggestions, {
        ref: suggestionsRef,
        children: suggestions.map(function(suggestion, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SuggestionItem, {
                query: query,
                suggestion: suggestion,
                isActive: index === focusedSuggestionIndex,
                handleSuggestionClick: function() {
                    return handleSuggestionClick(suggestion);
                },
                handleSuggestionMouseEnter: function() {
                    return handleSuggestionMouseEnter(index);
                },
                handleSuggestionMouseLeave: handleSuggestionMouseLeave
            }, suggestion.id);
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@ev/search-api/dist/index.mjs + 47 modules
var dist = __webpack_require__(3043);
;// CONCATENATED MODULE: ./src/components/modules/SearchForm/utils/fetchSearchLink.ts




var fetchSearchLink = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(tenant, selectedSuggestion, language, searchFilters) {
        var propertyFilter, _tmp, _tmp1, _tmp2, link, _tmp3, _tmp4, ref;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (selectedSuggestion.isDisplayId) {
                        return [
                            2,
                            (0,propertyData/* getExposeUrl */.qu)(selectedSuggestion.id, language, tenant)
                        ];
                    }
                    _tmp = {};
                    _tmp1 = {};
                    _tmp2 = {};
                    propertyFilter = [
                        (_tmp.field = "marketingType", _tmp.filter = {
                            value: searchFilters === null || searchFilters === void 0 ? void 0 : searchFilters.marketingType
                        }, _tmp),
                        (searchFilters === null || searchFilters === void 0 ? void 0 : searchFilters.kind) ? (_tmp1.field = "kind", _tmp1.filter = {
                            value: searchFilters === null || searchFilters === void 0 ? void 0 : searchFilters.kind
                        }, _tmp1) : (_tmp2.field = "objectType", _tmp2.filter = {
                            value: searchFilters === null || searchFilters === void 0 ? void 0 : searchFilters.objectType
                        }, _tmp2)
                    ];
                    _tmp3 = {};
                    _tmp4 = {};
                    return [
                        4,
                        (0,dist/* getLinkToSearchResultPage */.ud)((_tmp3.placeId = selectedSuggestion.id, _tmp3.description = selectedSuggestion.description, _tmp3.type = selectedSuggestion.type, _tmp3), (_tmp4.filters = propertyFilter, _tmp4))
                    ];
                case 1:
                    link = _state.sent();
                    return [
                        2,
                        (ref = (0,propertyData/* createSearchLink */.Dj)(link, language, tenant)) !== null && ref !== void 0 ? ref : ""
                    ];
            }
        });
    });
    return function fetchSearchLink(tenant, selectedSuggestion, language, searchFilters) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./src/components/modules/SearchForm/SearchForm.tsx
















var MIN_CHARACTERS_FOR_SUGGESTIONS = 3;
var SearchForm = function(param) {
    var className = param.className, placeholder = param.placeholder, propertyTypeOptions = param.propertyTypeOptions, propertyTypeButtonLabel = param.propertyTypeButtonLabel, marketingTypeOptions = param.marketingTypeOptions, marketingTypeLabel = param.marketingTypeLabel, trackingInfo = param.trackingInfo;
    var router = (0,next_router.useRouter)();
    var asPath = router.asPath;
    var ref = (0,getSlugFromPath/* getSlugFromPath */.S)(asPath), _language = ref.language, language = _language === void 0 ? "en" : _language, tenant = ref.tenant;
    var isTablet = (0,useIsSmallerThan/* useIsSmallerThan */.s)("LAPTOP");
    var isMobile = (0,useIsSmallerThan/* useIsSmallerThan */.s)("TABLET_PORTRAIT");
    var ref1 = (0,react.useState)(""), query = ref1[0], setQuery = ref1[1];
    var ref2 = (0,react.useState)(0), focusedSuggestionIndex = ref2[0], setFocusedSuggestionIndex = ref2[1];
    var ref3 = (0,react.useState)(null), firstSuggestion = ref3[0], setFirstSuggestion = ref3[1];
    var ref4 = (0,react.useState)([]), suggestions = ref4[0], setSuggestions = ref4[1];
    var ref5 = (0,react.useState)({
        marketingType: undefined,
        objectType: undefined,
        kind: undefined
    }), propertyFilter = ref5[0], setPropertyFilter = ref5[1];
    var ref6 = (0,react.useState)(false), isNavigating = ref6[0], setIsNavigating = ref6[1];
    var ref7 = (0,react.useState)(0), offset = ref7[0], setOffset = ref7[1];
    var containerRef = (0,react.useRef)(null);
    var suggestionsRef = (0,react.useRef)(null);
    var inputFieldRef = (0,react.useRef)(null);
    var snowplow = (0,useSnowplow/* useSnowplow */.a)().snowplow;
    var closeSuggestions = function() {
        return setSuggestions([]);
    };
    (0,useOnClickOutside/* useOnClickOutside */.t)(suggestionsRef, closeSuggestions);
    (0,react.useEffect)(function() {
        var ref;
        setOffset((containerRef === null || containerRef === void 0 ? void 0 : (ref = containerRef.current) === null || ref === void 0 ? void 0 : ref.getBoundingClientRect().top) || 0);
        var onScroll = function() {
            if (containerRef === null || containerRef === void 0 ? void 0 : containerRef.current) {
                var ref;
                setOffset(containerRef === null || containerRef === void 0 ? void 0 : (ref = containerRef.current) === null || ref === void 0 ? void 0 : ref.getBoundingClientRect().top);
            }
        };
        window.addEventListener("scroll", onScroll, {
            passive: true
        });
        return function() {
            return window.removeEventListener("scroll", onScroll);
        };
    }, []);
    var fetchLocationSuggestions = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(query) {
            var locationSuggestions, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (query.length < MIN_CHARACTERS_FOR_SUGGESTIONS) {
                            setSuggestions([]);
                            return [
                                2
                            ];
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            (0,api/* fetchSuggestions */.mO)(query, language)
                        ];
                    case 2:
                        locationSuggestions = _state.sent();
                        setSuggestions(locationSuggestions);
                        // Saves first suggestion so search works when user does not select an option
                        setFirstSuggestion(locationSuggestions[0]);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        console.error("Error fetching location suggestions:", error);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function fetchLocationSuggestions(query) {
            return _ref.apply(this, arguments);
        };
    }();
    var onChange = function(e) {
        var value = e.target.value;
        setQuery(value);
        fetchLocationSuggestions(value);
    };
    // Simulate a delay to show a selected suggestion before navigate to page
    var navigateToSearchPageUrl = function(url) {
        setIsNavigating(true);
        setTimeout(function() {
            window.open(url, "_self", "noopener");
        }, 500);
    };
    var navigateToSuggestionSearchPage = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(suggestion) {
            var _tmp, searchLink;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = {};
                        return [
                            4,
                            snowplow.trackSearchEvent((_tmp.searchTermTyped = query, _tmp.searchTermSelected = suggestion, _tmp.selectedTermPosition = focusedSuggestionIndex, _tmp.totalSearchTerms = suggestions.length, _tmp.propertyType = propertyFilter.objectType || "all", _tmp.searchIntent = propertyFilter.marketingType || propertyData/* marketingTypeValues.buy */.bG.buy, _tmp))
                        ];
                    case 1:
                        _state.sent();
                        if (!(suggestion === null || suggestion === void 0 ? void 0 : suggestion.description)) return [
                            3,
                            3
                        ];
                        setQuery(suggestion.description);
                        setSuggestions([]);
                        return [
                            4,
                            fetchSearchLink(tenant, suggestion, language, propertyFilter)
                        ];
                    case 2:
                        searchLink = _state.sent();
                        navigateToSearchPageUrl(searchLink);
                        _state.label = 3;
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function navigateToSuggestionSearchPage(suggestion) {
            return _ref.apply(this, arguments);
        };
    }();
    // keyboard navigation for the suggestion list
    var handleKeyDown = (0,useKeyboardNavigation/* useKeyboardNavigation */.t)(focusedSuggestionIndex, setFocusedSuggestionIndex, suggestions, navigateToSuggestionSearchPage).handleKeyDown;
    // mouse navigation for the suggestion list
    var handleSuggestionMouseEnter = function(index) {
        setFocusedSuggestionIndex(index);
    };
    var handleSuggestionMouseLeave = function() {
        setFocusedSuggestionIndex(0);
    };
    var handleSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(e) {
            var marketingTypeValue, kind, objectType, marketingType, _tmp, ref, url, _tmp1, _tmp2;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        e.preventDefault();
                        if (!firstSuggestion) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            navigateToSuggestionSearchPage(firstSuggestion)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                    case 2:
                        marketingTypeValue = propertyFilter.marketingType || propertyData/* marketingTypeValues.buy */.bG.buy;
                        kind = propertyFilter.kind ? "kind=".concat(propertyFilter.kind) : null;
                        objectType = propertyFilter.objectType ? "objectType=".concat(propertyFilter.objectType) : null;
                        marketingType = "marketingType=".concat(marketingTypeValue);
                        _tmp = {};
                        return [
                            4,
                            snowplow.trackSearchEvent((_tmp.propertyType = propertyFilter.objectType || "all", _tmp.searchIntent = marketingTypeValue, _tmp))
                        ];
                    case 3:
                        _state.sent();
                        url = (0,appendSphParam/* appendSphParam */.c)(router, "".concat(propertyData/* SEARCH_WEBSITE */.y8, "/").concat(language, "/propertysearch?").concat((ref = kind || objectType) !== null && ref !== void 0 ? ref : "", "&").concat(marketingType));
                        _tmp1 = {};
                        _tmp2 = {};
                        snowplow.trackNavigationCustomEvent((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)(_tmp1, trackingInfo), (_tmp2.href = url, _tmp2)));
                        window.open(url, "_self", "noopener, noreferrer");
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSubmit(e) {
            return _ref.apply(this, arguments);
        };
    }();
    var cleanInput = function() {
        var ref;
        setQuery("");
        setFirstSuggestion(null);
        inputFieldRef === null || inputFieldRef === void 0 ? void 0 : (ref = inputFieldRef.current) === null || ref === void 0 ? void 0 : ref.focus();
    };
    var onChangePropertyType = function(value) {
        var typeFilters = {};
        if (value === "all") {
            typeFilters.kind = undefined;
            typeFilters.objectType = undefined;
        } else if (value === "group") {
            typeFilters.kind = "group";
            typeFilters.objectType = undefined;
        } else {
            typeFilters.kind = undefined;
            typeFilters.objectType = value;
        }
        setPropertyFilter(function(prevFilters) {
            return (0,_object_spread/* default */.Z)({}, prevFilters, typeFilters);
        });
    };
    var onChangeMarketingType = function(value) {
        setPropertyFilter(function(prevFilters) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevFilters), {
                marketingType: value
            });
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledContainer, {
        ref: containerRef,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTextRadio, {
                items: marketingTypeOptions,
                defaultValue: marketingTypeOptions[0].value,
                onChange: onChangeMarketingType,
                label: marketingTypeLabel
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledForm, {
                className: className,
                onSubmit: handleSubmit,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectWithIcon, {
                        options: propertyTypeOptions,
                        onChange: onChangePropertyType,
                        buttonLabel: propertyTypeButtonLabel
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSearchInputWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchInput, {
                            query: query,
                            placeholder: placeholder,
                            ref: inputFieldRef,
                            onChange: onChange,
                            onKeyDown: handleKeyDown,
                            cleanInput: cleanInput,
                            onFocus: function() {
                                if (isTablet && offset >= 128 && (containerRef === null || containerRef === void 0 ? void 0 : containerRef.current)) {
                                    var ref;
                                    window.scrollTo({
                                        behavior: "smooth",
                                        top: (containerRef === null || containerRef === void 0 ? void 0 : (ref = containerRef.current) === null || ref === void 0 ? void 0 : ref.offsetTop) - 40
                                    });
                                }
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledIconButton, {
                        shape: "square",
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Search, {}),
                        variant: "search",
                        size: isMobile ? "small" : "medium",
                        label: "search",
                        type: "submit",
                        forwardedAs: "button",
                        $isActive: isNavigating
                    })
                ]
            }),
            suggestions.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(SuggestionList, {
                query: query,
                suggestions: suggestions,
                focusedSuggestionIndex: focusedSuggestionIndex,
                handleClickOutside: closeSuggestions,
                handleSuggestionClick: navigateToSuggestionSearchPage,
                handleSuggestionMouseEnter: handleSuggestionMouseEnter,
                handleSuggestionMouseLeave: handleSuggestionMouseLeave
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/elements/Headline/Headline.tsx
var Headline = __webpack_require__(6745);
// EXTERNAL MODULE: ./src/components/utils/gridCalc.ts
var gridCalc = __webpack_require__(3986);
// EXTERNAL MODULE: ./src/components/modules/SuggestionRow/SuggestionRow.tsx + 1 modules
var SuggestionRow = __webpack_require__(5695);
// EXTERNAL MODULE: ./src/components/modules/Wrapper/Wrapper.tsx + 1 modules
var Wrapper = __webpack_require__(8709);
;// CONCATENATED MODULE: ./src/components/modules/SearchHero/SearchHero.styles.ts

function SearchHero_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      padding-bottom: 0;\n    "
    ]);
    SearchHero_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SearchHero_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: var(--distance-dynamic-xl);\n  padding-top: var(--distance-static-xxl);\n\n  @media screen and (",
        ") {\n    margin-bottom: 0;\n  }\n\n  ",
        "\n"
    ]);
    SearchHero_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SearchHero_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  gap: var(--distance-static-xxl);\n  align-items: flex-end;\n  margin-bottom: var(--distance-static-xxl);\n\n  @media screen and (",
        ") {\n    grid-template-columns: 1fr 1fr;\n    gap: var(--distance-static-l);\n  }\n"
    ]);
    SearchHero_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function SearchHero_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media screen and (",
        ") {\n    padding-right: ",
        ";\n  }\n"
    ]);
    SearchHero_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function SearchHero_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-bottom: 0;\n\n  @media screen and (",
        ") {\n    padding-top: 0;\n    transform: translateY(calc(var(--distance-static-3xl) * -1));\n    padding-right: var(--distance-static-3xl);\n    padding-left: var(--distance-static-3xl);\n  }\n\n  @media screen and (",
        ") {\n    padding-right: var(--distance-static-4xl);\n    padding-left: var(--distance-static-4xl);\n  }\n\n  @media screen and (",
        ") {\n    transform: translateY(-50%);\n  }\n"
    ]);
    SearchHero_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}





var StyledSearchHero = (0,styled_components_browser_esm/* default */.ZP)(Wrapper.Wrapper).withConfig({
    componentId: "sc-596747eb-0"
})(SearchHero_styles_templateObject1(), mediaQueries/* tabletPortrait */.ZI, function(param) {
    var $hasTeaser = param.$hasTeaser;
    return $hasTeaser && (0,styled_components_browser_esm/* css */.iv)(SearchHero_styles_templateObject());
});
var StyledHeader = styled_components_browser_esm/* default.header.withConfig */.ZP.header.withConfig({
    componentId: "sc-596747eb-1"
})(SearchHero_styles_templateObject2(), mediaQueries/* laptop */.PJ);
var StyledHeadline = (0,styled_components_browser_esm/* default */.ZP)(Headline/* Headline */.s).withConfig({
    componentId: "sc-596747eb-2"
})(SearchHero_styles_templateObject3(), mediaQueries/* laptop */.PJ, (0,gridCalc/* gridCalc */.T)(2));
var StyledSuggestionRow = (0,styled_components_browser_esm/* default */.ZP)(SuggestionRow/* SuggestionRow */.Y).withConfig({
    componentId: "sc-596747eb-3"
})(SearchHero_styles_templateObject4(), mediaQueries/* tabletPortrait */.ZI, mediaQueries/* tabletLandscape */.yJ, mediaQueries/* laptop */.PJ);

;// CONCATENATED MODULE: ./src/components/modules/SearchHero/SearchHero.tsx









var SearchHero = function(param) {
    var className = param.className, headline = param.headline, smallImage = param.smallImage, largeImage = param.largeImage, items = param.items, searchForm = param.searchForm, hasAnimation = param.hasAnimation;
    var searchHeroRef = (0,react.useRef)(null);
    var suggestionRowRef = (0,react.useRef)(null);
    var imageRef = (0,react.useRef)(null);
    var isMobile = (0,useIsSmallerThan/* useIsSmallerThan */.s)("TABLET_PORTRAIT");
    var isTabletLandscape = (0,useIsGreaterThan/* useIsGreaterThan */.Y)("TABLET_LANDSCAPE");
    var isLaptop = (0,useIsGreaterThan/* useIsGreaterThan */.Y)("LAPTOP");
    var image = isMobile ? smallImage : largeImage;
    var placeholder = searchForm.placeholder, propertyTypeOptions = searchForm.propertyTypeOptions, propertyTypeButtonLabel = searchForm.propertyTypeButtonLabel, marketingTypeOptions = searchForm.marketingTypeOptions, marketingTypeLabel = searchForm.marketingTypeLabel, trackingInfo = searchForm.trackingInfo;
    (0,useIsomorphicLayoutEffect/* useIsomorphicLayoutEffect */.L)(function() {
        if (!isTabletLandscape || !hasAnimation) return;
        gsap/* gsap.registerPlugin */.p8.registerPlugin((ScrollTrigger_default()), (CustomEase_default()));
        CustomEase_default().create("customEase", gsapVariables/* customEase */.p);
        var ctx = gsap/* gsap.context */.p8.context(function() {
            var tl = gsap/* gsap.timeline */.p8.timeline({});
            gsap/* gsap.from */.p8.from(suggestionRowRef.current, {
                scrollTrigger: {
                    trigger: suggestionRowRef.current,
                    start: isLaptop ? "top bottom" : "top-=50% bottom",
                    end: "+=45%",
                    toggleActions: "restart play resume reverse"
                },
                y: "50%",
                opacity: 0,
                duration: 0.8,
                ease: "customEase"
            });
            tl.to(imageRef.current, {
                scrollTrigger: {
                    trigger: searchHeroRef.current,
                    start: "top ".concat(gsapVariables/* headerHeight */.J),
                    end: "+=25%",
                    scrub: true
                },
                y: -16,
                ease: "customEase"
            });
            tl.to(searchHeroRef.current, {
                scrollTrigger: {
                    trigger: searchHeroRef.current,
                    start: "top ".concat(gsapVariables/* headerHeight */.J),
                    end: "+=25%",
                    scrub: true
                },
                y: -16,
                ease: "customEase"
            });
        }, searchHeroRef);
        return function() {
            return ctx.revert();
        };
    }, [
        isTabletLandscape,
        isLaptop,
        hasAnimation
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSearchHero, {
        className: className,
        forwardedAs: "section",
        width: {
            laptop: "xl",
            tabletLandscape: "l"
        },
        $hasTeaser: Boolean(items),
        ref: searchHeroRef,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHeader, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeadline, {
                        size: "h1",
                        forwardedAs: "p",
                        label: headline
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchForm, {
                        placeholder: placeholder,
                        propertyTypeOptions: propertyTypeOptions,
                        propertyTypeButtonLabel: propertyTypeButtonLabel,
                        marketingTypeOptions: marketingTypeOptions,
                        marketingTypeLabel: marketingTypeLabel,
                        trackingInfo: trackingInfo
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: imageRef,
                children: image
            }),
            items && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSuggestionRow, {
                tag: "div",
                items: items,
                ref: suggestionRowRef
            })
        ]
    });
};


/***/ })

}]);